// @flow
import * as GeneralButton from './general'

// Types
import type { Props } from './general'

export const StyledButton = (props: Props) => ({
  ...GeneralButton.StyledButton(props),
  fontWeight: 500,
  textTransform: 'uppercase',
})
